import { IAsset } from './types/data-types'

export const AppRoutes = {
  LOGIN: '/login',
  HOME: '/',
  STOCKS: '/stocks',
  STOCK_HOME_PAGE: {
    url: '/stocks/:id',
    getRoute: id => `/stocks/${id}`,
  },
  STOCK_DASH_BOARD: {
    url: '/stock/:id/dashboard',
    getRoute: id => `/stock/${id}/dashboard`,
  },
  STOCK_DISPOSE: {
    url: '/stock/:id/dispose',
    getRoute: id => `/stock/${id}/dispose`,
  },
  PROFILE: '/profile/overview',
  ADMIN_STOCKS: '/profile/stocks',
  APPLICATIONS: '/intranet/applications',
  CERTIFICATIONS: '/intranet/certifications',
  Features: '/intranet/features',
  BOAT_LIST: '/boatlist',
  ASSET_LIST: '/assets',
  CREATE_STOCK: '/profile/stocks/create',
  UPDATE_STOCK: { url: '/profile/stocks/:id', getRoute: id => `/profile/stocks/${id}` },
  PRODUCTS: '/profile/products',
  CREATE_PRODUCT: '/profile/products/create',
  UPDATE_PRODUCT: { url: '/profile/products/:id', getRoute: id => `/profile/products/${id}` },
  PRODUCT_CATEGORIES: '/profile/product-categories',
  CREATE_PRODUCT_CATEGORY: '/profile/product-categories/create',
  UPDATE_PRODUCT_CATEGORY: {
    url: '/profile/product-categories/:id',
    getRoute: id => `/profile/product-categories/${id}`,
  },
  PRODUCT_UNITS: '/intranet/product-units',
  CREATE_PRODUCT_UNIT: '/intranet/product-units/create',
  UPDATE_PRODUCT_UNIT: { url: '/intranet/product-units/:id', getRoute: id => `/intranet/product-units/${id}` },
  REQUESTS: '/profile/requests',
  PRODUCT_GROUPS: '/profile/product-groups',
  CREATE_PRODUCT_GROUP: '/profile/product-groups/create',
  UPDATE_PRODUCT_GROUP: { url: '/profile/product-groups/:id', getRoute: id => `/profile/product-groups/${id}` },
  WORK_ORDERS: {
    url: '/work-orders',
    getRoute: id => `/assets/${id}/work-orders`,
  },
  WORK_ORDER_PREVIEW: {
    url: '/work-orders/:workOrderId/preview',
    getRoute: (assetId, id) => `/assets/${assetId}/work-orders?Id=${id}`,
  },
  WORK_ORDER_PREVIEW_OLD: {
    url: '/work-orders/:workOrderId/preview',
    getRoute: (assetId, id) => `/assets/${assetId}/work-orders/${id}/preview`,
  },
  UPDATE_WORK_ORDER: {
    url: '/work-orders/:workOrderId',
    getRoute: (assetId, boatName, id) => `/assets/${assetId}/work-orders/${id}`,
  },
  CREATE_WORK_ORDER_SECTION: {
    url: '/work-orders/:workOrderId/sections/create',
    getRoute: (assetId, boatName, workOrderId) => `/assets/${assetId}/work-orders/${workOrderId}/sections/create`,
  },
  UPDATE_WORK_ORDER_SECTION: {
    url: '/assets/:id/work-orders/:workOrderId/sections/:sectionId',
    getRoute: (boatId, workOrderId, sectionId) => `/assets/${boatId}/work-orders/${workOrderId}/sections/${sectionId}`,
  },
  COMPLETE_WORK_ORDER_SECTION: {
    url: '/assets/:id/work-orders/:workOrderId/sections/:sectionId/complete',
    getRoute: (boatId, workOrderId, sectionId) =>
      `/assets/${boatId}/work-orders/${workOrderId}/sections/${sectionId}/complete`,
  },
  WORK_ORDER_PUBLIC: {
    url: 'work-order/:token',
    getRoute: token => `work-order/${token}`,
  },
  WORK_ORDER_SECTION_PUBLIC: {
    url: 'work-order/:token/section/:sectionId?',
    getRoute: (token, sectionId) =>
      sectionId ? `work-order/${token}/section/${sectionId}` : `/work-order/${token}/section`,
  },
  PUBLIC_STARTUP: {
    url: ':boatId/startup/:token',
    getRoute: (boatId, token) => `/public/${boatId}/startup/${token}`,
  },
  DATA_SOURCES: '/profile/data-sources',
  CREATE_DATA_SOURCE: '/profile/data-sources/create',
  UPDATE_DATA_SOURCE: { url: '/profile/data-sources/:id', getRoute: id => `/profile/data-sources/${id}` },
  CHECKLISTS: '/profile/checklists',
  UPDATE_CHECKLIST: { url: '/profile/checklists/:id', getRoute: id => `/profile/checklists/${id}` },
  NOT_FOUND: '/not-found',
  CHECKLIST_STATISTICS: '/profile/checklist-statistics',
  CHECKLIST_COMPLETION_PREVIEW: {
    url: '/profile/checklist-completion/:id/preview',
    getRoute: id => `/profile/checklist-completion/${id}/preview`,
  },
  WORK_ORDER_TEMPLATES: '/profile/work-order-templates',
  CREATE_WORK_ORDER_TEMPLATE: '/profile/work-order-templates/create',
  UPDATE_WORK_ORDER_TEMPLATE: {
    url: '/profile/work-order-templates/:workOrderId',
    getRoute: id => `/profile/work-order-templates/${id}`,
  },
  WORK_ORDER_TEMPLATE_PREVIEW: {
    url: '/profile/work-order-templates/:workOrderId/preview',
    getRoute: id => `/profile/work-order-templates/${id}/preview`,
  },
  CREATE_WORK_ORDER_TEMPLATE_SECTIONS: {
    url: '/profile/work-order-templates/:workOrderId/sections/create',
    getRoute: id => `/profile/work-order-templates/${id}/sections/create`,
  },
  UPDATE_WORK_ORDER_TEMPLATE_SECTION: {
    url: '/profile/work-order-templates/:workOrderId/sections/:sectionId',
    getRoute: (workOrderId, sectionId) => `/profile/work-order-templates/${workOrderId}/sections/${sectionId}`,
  },
  STARTUP_ROUTINES: '/profile/startup-routines',
  CREATE_STARTUP_ROUTINE: '/profile/startup-routines/create',
  UPDATE_STARTUP_ROUTINE: {
    url: '/profile/startup-routines/:id',
    getRoute: id => `/profile/startup-routines/${id}`,
  },
  BOAT_ROUTINE_HISTORY: '/assets/:id/startup-routines-history',
  BOAT_CHECKLISTS: '/assets/:id/checklists',
  RISK_ANALYSIS_ADMIN: '/profile/risk-analysis',
  LOGBOOK_CONFIGURATION: '/profile/logbook-configuration',
  SOP_STORAGE: '/profile/standard-operating-procedures',
  TAGS: '/profile/tags',
  CREATE_RISK_ANALYSIS_TASK: '/profile/risk-analysis/create',
  UPDATE_RISK_ANALYSIS_TASK: {
    urL: '/profile/risk-analysis/:id',
    getRoute: id => `/profile/risk-analysis/${id}`,
  },
  BOAT_RISK_ANALYSIS: '/assets/:id/risk-analysis',
  RISK_ANALYSIS_SUPERADMIN: '/intranet/risk-analysis',
  CREATE_RISK_ANALYSIS_TASK_SUPERADMIN: '/intranet/risk-analysis/create',
  UPDATE_RISK_ANALYSIS_TASK_SUPERADMIN: {
    urL: '/intranet/risk-analysis/:id',
    getRoute: id => `/intranet/risk-analysis/${id}`,
  },
  WORKSHOPS: '/profile/workshops',
  ADMIN_CERTIFICATIONS: '/profile/certifications',
  ADMIN_MAIN_CATEGORIES: '/profile/main-categories',
  CREATE_WORKSHOP: '/profile/workshops/create',
  UPDATE_WORKSHOP: {
    url: '/profile/workshops/:id',
    getRoute: id => `/profile/workshops/${id}`,
  },
  HOME_WORKSHOPS: '/workshops',
  HOME_WORKSHOP: {
    url: '/workshops/:id',
    getRoute: id => `/workshops/${id}`,
  },
  WORKSHOP_BOAT_SCREEN: {
    url: '/workshops/:id/boats/:wbId',
    getRoute: (workshopId, wbId) => `/workshops/${workshopId}/boats/${wbId}`,
  },
  WORKSHOP_BOAT_ORDER_SCREEN: {
    url: '/workshops/:id/work-order/:workOrderId',
    getRoute: (workshopId, workOrderId) => `/workshops/${workshopId}/work-order/${workOrderId}`,
  },
  USER_EMAILS: '/profile/user-emails',
  USER_DEVICES: '/profile/user-devices',
  ASSET_DOCUMENTS: {
    url: 'documentation',
    getRoute: (asset: IAsset) => `/assets/${asset.assetId}/documentation`,
    getRouteDeconstructed: (assetId: EntityId) => `/assets/${assetId}/documentation`,
  },
  ASSET_DEVIATIONS: {
    url: '/assets/:id/deviation"',
    getRoute: (assetId: EntityId) => `/assets/${assetId}/deviation`,
  },
  BOAT_DOCUMENT_FOLDER: {
    url: 'documentation/folders/:folderId',
    getRoute: (boat: IAsset, folderId: EntityId) => `/assets/${boat.assetId}/documentation/folders/${folderId}`,
  },
  ASSET_SERVICES: {
    url: '/assets/:id/service"',
    getRoute: (boatId: EntityId) => `/assets/${boatId}/service`,
  },
  CALENDAR: '/calendar',
  USERDASHBOARD: '/userDashboard',
  HELP: '/help',
  REPORTS: '/profile/reports',
  DEVIATIONS: '/profile/deviations',
  EXERCISES: '/profile/exercises',
  CREATE_EXERCISE: '/profile/exercises/create',
  UPDATE_EXERCISE: { url: '/profile/exercises/:id', getRoute: (id: EntityId) => `/profile/exercises/${id}` },
  BOAT_EXERCISES: {
    url: '/exercises',
    getRoute: (asset: IAsset) => `/assets/${asset.assetId}/exercises`,
  },
  CREATE_BOAT_EXERCISE: {
    url: '/exercises/create',
    getRoute: (asset: IAsset) => `/assets/${asset.assetId}/exercises/create`,
  },
  UPDATE_BOAT_EXERCISE: {
    url: '/assets/:id/exercises/:exerciseId',
    getRoute: (asset: IAsset, exerciseId: EntityId) => `/assets/${asset.assetId}/exercises/${exerciseId}`,
  },
  ASSET: {
    url: '/assets/:id/',
    getRoute: (id: number) => `/assets/${id}`,
  },
  SUPPLIERS: '/profile/suppliers',
  SENSORTYPES: '/intranet/sensor/types',
  SENSORPERMISSION: '/intranet/sensor/distributors',
  ACCESSCONTROL: '/intranet/accesscontrol',
} as const
